import Icon from "@components/Icon/Icon";
import Button from "@src/app/components/AccessibleComponents/Button";
import cx from "classnames";

export type ToggleSideMenuButtonProps = {
  onClick: () => void;
};

export default function ToggleSideMenuButton({
  onClick,
}: ToggleSideMenuButtonProps): React.ReactElement {
  return (
    <Button
      aria-label="Toggle side menu"
      className={cx(
        "cursor-pointer p-2 opacity-100 duration-300",
        "xl:p-3",
        "hover:opacity-75"
      )}
      onPress={onClick}
    >
      <Icon type="bar" />
    </Button>
  );
}
